/** Watching other people's games: the list to pick from, and the one being watched, live. */
export const GET_WATCH_LIST = 'WATCH/GET_WATCH_LIST';
export const SET_WATCH_LIST = 'WATCH/SET_WATCH_LIST';
export const WATCH_GAME = 'WATCH/WATCH_GAME';
export const SET_WATCHED = 'WATCH/SET_WATCHED';
